<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped></style>

<template>
    <div>
        <!-- Main Loader Component, it displays
        as an overlay over the whole application -->
        <div class="veil">
            <div class="underlay">
                <div class="spinner"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Loader",
};
</script>
